import React from "react";
import { CircularProgress } from "@mui/material";

import * as S from "./styles";

export default function Button({
  children = "Button Name",
  disabled = false,
  loading = false,
  button,
  buttonTheme = "active",
  fontSize = "1.5rem",
  height = "2.5rem",
  width = "10.1rem",
  minWidth = "0rem",
  onClick,
  ...rest
}) {
  const handleClick = (e) => {
    if (!loading) {
      onClick(e);
    }
  };

  return (
    <S.Wrapper
      button={button}
      buttonTheme={disabled ? "goback" : buttonTheme}
      disabled={disabled || loading}
      fontSize={fontSize}
      height={height}
      width={width}
      minWidth={minWidth}
      onClick={handleClick}
      {...rest}
    >
      {loading && buttonTheme === "active" ? (
        <CircularProgress color="inherit" size={24} />
      ) : (
        !!children && children
      )}
    </S.Wrapper>
  );
}
